export default "__VITE_ASSET__CEOP3NFO__"